import { render } from "./MarketplaceLeaderboard.vue?vue&type=template&id=32e1be09&scoped=true"
import script from "./MarketplaceLeaderboard.vue?vue&type=script&lang=js"
export * from "./MarketplaceLeaderboard.vue?vue&type=script&lang=js"

import "./MarketplaceLeaderboard.vue?vue&type=style&index=0&id=32e1be09&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e1be09"]])

export default __exports__